{
  "badRequestMessage": "Wystąpił nieoczekiwany błąd",
  "incorrectlyFilledFields": "Formularz zawiera błędy. Wprowadź poprawne dane.",
  "authErrorMessage": "Niepoprawne uwierzytelnianie",
  "formHasWarnings": "Do wypełnionych danych pojawiły się ostrzeżenia. Komunikaty zostały wypisane przy odpowiednich polach.",
  "operationNotSupported": "Operacja nie jest obsługiwana."
}
